import push from '../../utils/routing';

export default ({ spaceId, postId }) =>
  () =>
    push(`/dashboard/${spaceId}/community/post/${postId}`);
